import Shake from './behaviors/shake/ShakePosition.js';
export default Shake;